import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from "@angular/core";
import {
  FormControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { NavigationExtras, Router } from "@angular/router";
import {
  AvailabilityPriceRequest,
  CabinType,
  FlightAvailReq,
  FlightAvailRes,
  JourneyRequest,
  JourneysReferences,
  PaxesDistribution,
  Rule,
  SearchCriteria,
  Solution,
  TransportRequest,
} from "@core/models";
import {
  CompanyService,
  FlightLleegoService,
  NgxToastrService,
  StateService,
  TravelService,
  UserService,
  UtilsService,
} from "@core/services";
import {
  NgbActiveModal,
  NgbDateParserFormatter,
} from "@ng-bootstrap/ng-bootstrap";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { CustomDateParserFormatter } from "@shared/component/date-parser";
import newAirports from "assets/utils/airports.json";
import airports from "assets/utils/amadeus/airports.json";
import moment from "moment";
import { catchError, forkJoin, of, Subscription, tap } from "rxjs";
import { AppState } from "../../search/search.reducer";
import { DialogTravelersComponent } from "../../../shared/component/dialog-travelers/dialog-travelers.component";
import { default as swal } from "sweetalert2";
import municipalitiesJson from "../../../../../assets/utils/resident-municipalities.json";
import { DialogAssignProjectComponent } from "@shared/component/dialog-assign-project/dialog-assign-project.component";

@Component({
  selector: "app-flight-form",
  templateUrl: "./flight-form.component.html",
  styleUrls: ["./flight-form.component.scss"],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
})
export class FlightFormComponent implements OnInit, OnDestroy {
  modal = false;
  formSearchFlight: UntypedFormGroup;
  oneWay = false;
  isAdmin = false;
  isEmployee = false;
  canUseTRM: boolean;
  userToBook: string;
  flightListResult;
  originSelected: string;
  destinationSelected: string;
  flightAvailRes: FlightAvailRes;
  outwardList: JourneysReferences[] = [];
  returnList: JourneysReferences[] = [];
  transportRequest: TransportRequest;
  companyUuid: string;
  userUuid: string;
  airportList: any[] = [];
  seats = [
  ];

  searchHasFailed = false;
  @Output() firstSearch: EventEmitter<any> = new EventEmitter<any>();
  @Output() emitSelectedTravelers: EventEmitter<any> = new EventEmitter<any>();
  @Output() emitProject = new EventEmitter<any>();
  @Output() emitCabin = new EventEmitter<any>();
  loadingFlights = false;
  flightAvailReq: FlightAvailReq;

  date = new Date();
  minDateNgStruct = {
    year: this.date.getFullYear(),
    month: this.date.getMonth() + 1,
    day: this.date.getDate(),
  };
  maxDateNgStruct = {
    year: this.date.getFullYear() + 20,
    month: this.date.getMonth() + 1,
    day: this.date.getDate(),
  };

  user;
  destinationRadius;
  originRadius;
  private subcriptions: Subscription[] = [];
  userFilters: any;
  munipalitiesList = municipalitiesJson;

  companyUsers: { name: string; lastname: string; uuid: string }[] = [];
  defaultUser: any;
  travelers: any[] = [];
  @Input() travelersSelected: any;
  @Input() projectDataSaved: any;
  public filterControl = new FormControl();
  public filteredUsers: { name: string; lastname: string; uuid: string }[];
  projects: any[];
  selectedProject: any = null;
  loadingProjects: boolean = false; 
  passengersModalOpen: boolean = false;
  policies: any[] = [];
  loadingPolicies: boolean = false;
  private userPoliciesCache: { [userUuid: string]: any[] } = {};
  @Input() selectedPolicy: any = null;
  @Output() emitSelectedPolicy = new EventEmitter<any>();
  private policiesSub?: Subscription;
  private lastPoliciesRequestKey: string | null = null;
  accomInfo;
  isPackageRate: string;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public translate: TranslateService,
    private ngxToastrService: NgxToastrService,
    public utilsService: UtilsService,
    public activeModal: NgbActiveModal,
    public stateService: StateService,
    private store: Store<AppState>,
    private userService: UserService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<FlightFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private flightLleegoService: FlightLleegoService, // @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private companyService: CompanyService,
    private travelService: TravelService
  ) {
    this.subcriptions.push(
      this.store.select("auth").subscribe((s: any) => {
        if (s.user && s.user.type?.toUpperCase() !== "USER") {
          this.isAdmin = true;
          this.user = s.user;
          if (s.user.type?.toUpperCase() === "EMPLOYEE") {
            this.isEmployee = true;
          }
          this.userToBook = localStorage.getItem("userToBook")
            ? this.utilsService.decrypt(localStorage.getItem("userToBook"))
            : null;
          if (this.userToBook != null) {
            this.userUuid = this.userToBook;
            this.userService.getUserByUuid(this.userUuid).subscribe((user) => {
              if (!this.stateService.flightTravelers || this.stateService.flightTravelers.length <= 0) {
                this.stateService.flightTravelers = [ moment().diff(user.birthdate, "years")];
              }
              this.user = user;
            });
          } else {
            this.userUuid = s.user.uuid;
            if (!this.stateService.flightTravelers || this.stateService.flightTravelers.length <= 0) {
              this.stateService.flightTravelers = [moment().diff(s.user.birthdate, "years")];
            }
          }
          this.canUseTRM = s.user.type
            ? s.user.plan && s.user.plan.permissions.canUseTRM
            : s.user.user.plan && s.user.user.plan.permissions.canUseTRM;
        } else {
          this.userUuid = s.user.uuid;
          this.user = s.user;
          if (!this.stateService.flightTravelers || this.stateService.flightTravelers.length <= 0) {
            this.stateService.flightTravelers = [moment().diff(s.user.birthdate, "years")];
          }
          this.companyUuid = s.user.companyUuid;
        }
      })
    );
    this.modal = data.modal ? data.modal : false;
    this.travelersSelected = data?.travelersSelected ?? [];
    this.projectDataSaved = data?.projectDataSaved ?? null;
    this.selectedPolicy = data?.selectedPolicy ?? null;
  }

  ngOnInit(): void {
    this.isPackageRate = localStorage.getItem('isPackageRate')
    const accom = localStorage.getItem("packageRateAccomInfo");
    if (accom) {
      this.accomInfo = JSON.parse(accom)
    }
    this.getCompanyUsers();
    this.utilsService.clearProcessedUuids();

    if(this.projectDataSaved){
      this.projects = this.projectDataSaved.allProjects;
      this.selectedProject = this.projectDataSaved.selectedProject;
    }
    if (!this.modal && (!this.travelersSelected || this.travelersSelected.length === 0)) {
      this.stateService.flightTravelers = [];
    }

    if (this.travelersSelected && this.travelersSelected.length > 0) {
      const travelersSelectedCopy = [...this.travelersSelected];

      this.travelers = travelersSelectedCopy;
      if (!this.stateService.flightTravelers || this.stateService.flightTravelers.length <= 0) {
        this.stateService.flightTravelers = [moment().diff(this.travelersSelected[0].birthdate, "years") , ...travelersSelectedCopy.map(user => ( moment().diff(user.birthdate, "years") ))];
      }
    }

    if (this.stateService.flightSelectedState != null) {
      this.flightListResult = this.stateService.flightSelectedState;
    }
    if (this.stateService.transportRequest != null) {
      this.transportRequest = this.stateService.transportRequest;
    }
    if (this.stateService.destinationSelected != null) {
      this.destinationSelected = this.stateService.destinationSelected;
    }
    if (this.stateService.originSelected != null) {
      this.originSelected = this.stateService.originSelected;
    }
    if (this.stateService.flightSearchForm != null) {
      this.formSearchFlight = this.stateService.flightSearchForm;
      if (this.stateService.flightSearchForm.get("roundtrip").value) {
        this.oneWay = false;
      } else {
        this.oneWay = true;
      }
    } else {
      this.formSearchFlight = this.formBuilder.group({
        origin: [null, [Validators.required]],
        originNearAirports: [false],
        dateIn: [null, [Validators.required]],
        dateOut: [null],
        destination: [null, [Validators.required]],
        destinationNearAirports: [false],
        onlyDirect: [false],
        roundtrip: [
          this.stateService.flightSearchForm
            ? this.stateService.flightSearchForm.get("roundtrip").value
            : !this.oneWay,
          [Validators.required],
        ],
        type: ["ALL", [Validators.required]],       
        travelers: [
          this.travelers,
          [Validators.required],
        ],
        sources: [1, [Validators.required]],
        allowBaggage: [false],
        allowCancelation: [false],  
        arrivalSameDay: [false],
        companies: [[]],
      });
    }
    if (!this.travelersSelected) {
      this.updateTravelers();
    }
    this.pushAllSeatTypes();
    // política de clase comentada hasta cambio de proveedor
    // this.getSeatFilters();
    this.getPolicies();
    this.loadPoliciesForCurrentTravelers();
  }

  ngOnDestroy(): void {
    this.isPackageRate = null
  }

  switchDestination() {
    const destination = this.formSearchFlight.get("destination").value;
    const origin = this.formSearchFlight.get("origin").value;
    const originSel = this.originSelected;
    const destinationSel = this.destinationSelected;
    this.originSelected = destinationSel;
    this.destinationSelected = originSel;
    this.stateService.originSelected = this.originSelected;
    this.stateService.destinationSelected = this.destinationSelected;
    this.formSearchFlight.controls.destination.setValue(origin);
    this.formSearchFlight.controls.origin.setValue(destination);
  }

  returnTrip(value: boolean) {
    this.oneWay = value;
    const validator = this.oneWay ? null : [Validators.required];
    this.formSearchFlight.get("roundtrip").setValue(!this.oneWay);
    this.formSearchFlight.get("dateOut").setValidators(validator);
    this.formSearchFlight.get("dateOut").updateValueAndValidity();
  }

  getAirports(value: string) {
    this.airportList = [];
    if (value !== "" && value.length > 2) {
      newAirports["Table1"].forEach((e) => {
        if (
          (e.name &&
            (e.name.includes(value) ||
              e.name
                ?.toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .includes(
                  value
                    ?.toLowerCase()
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                ))) ||
          (e.IATA &&
            (e.IATA.includes(value) ||
              e.IATA?.toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .includes(
                  value
                    ?.toLowerCase()
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                ))) ||
          (e.country &&
            (e.country.includes(value) ||
              e.country
                ?.toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .includes(
                  value
                    ?.toLowerCase()
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                ))) ||
          (e.city &&
            (e.city.includes(value) ||
              e.city
                ?.toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .includes(
                  value
                    ?.toLowerCase()
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                )))
        ) {
          this.airportList.push({
            title:
              e.city.trim() +
              "/" +
              e.name.trim() +
              " " +
              "(" +
              e.IATA.trim() +
              ")",
            iata: e.IATA.trim(),
            coordinates: {
              latitude: e.lat.trim(),
              longitude: e.lon.trim(),
            },
          });
        }
      });
      airports.Table1.forEach((e) => {
        if (
          e.AirportName.includes(value) ||
          e.AirportName?.toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .includes(
              value
                ?.toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
            ) ||
          e.IATA.includes(value) ||
          e.IATA?.toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .includes(
              value
                ?.toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
            ) ||
          e.Country.includes(value) ||
          e.Country?.toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .includes(
              value
                ?.toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
            )
        ) {
          // comprobamos que el aeropuerto no se repita en la lista primigenia
          if (
            !this.airportList.some((f) =>
              f.title?.toLowerCase().includes(`${value?.toLowerCase()}`)
            )
          ) {
            this.airportList.push({
              title: e.AirportName + " " + "(" + e.IATA + ")",
              iata: e.IATA.trim(),
              coordinates: {
                latitude: e.Latitude,
                longitude: e.Longitude,
              },
            });
          }
        }
      });
    } else {
      this.airportList = [];
    }
  }

  optionSelected(field: string, value: string) {
    if (this.airportList.length > 0) {
      if (field === "origin") {
        this.originSelected = this.airportList.find(
          (a) => a.title === value
        ).iata;
        this.stateService.originSelected = this.originSelected;
        this.airportList = [];
      }
      if (field === "destination") {
        this.destinationSelected = this.airportList.find(
          (a) => a.title === value
        ).iata;
        this.stateService.destinationSelected = this.destinationSelected;
        this.airportList = [];
      }
    }
  }

  // política de clase comentada hasta cambio de proveedor
  // getSeatFilters() {
  //   this.subcriptions.push(
  //     this.userService.getPoliciesUser(this.userUuid).subscribe((g) => {
  //       this.userFilters = g.filters;
  //       if (g.filters.sitType) {
  //         this.pushSeatType(g.filters.sitType);
  //       }
  //     })
  //   );
  // }

  getPolicies(){
    this.subcriptions.push(
        this.userService.getPoliciesUser(this.userUuid).subscribe((g) => {
          this.userFilters = g.filters;
      })
    );
  }

  getTravelerPlaceholder(): string {
    let placeholder = "";
    this.translate
      .get(["flight.form-flight.passengers", "flight.form-flight.passenger"])
      .subscribe((result) => {
        if (this.stateService.flightTravelers.length > 0) {
          placeholder =
            this.stateService.flightTravelers.length.toString() +
            " " +
            (this.stateService.flightTravelers.length > 1
              ? result["flight.form-flight.passengers"]
              : result["flight.form-flight.passenger"]);
        }
      });
    return placeholder;
  }

  // política de clase comentada hasta cambio de proveedor
  // private pushSeatType(type) {
  //   this.seats = [];
  //   switch (type) {
  //     case "ECONOMY":
  //       this.seats.push({
  //         value: "Y",
  //         viewValue: "Economy",
  //       });
  //       break;
  //     case "PREMIUM_ECONOMY":
  //       this.seats.push(
  //         {
  //           value: "Y",
  //           viewValue: "Economy",
  //         },
  //         {
  //           value: "M",
  //           viewValue: "Economic Standard",
  //         },
  //         {
  //           value: "W",
  //           viewValue: "Economic Premium",
  //         }
  //       );
  //       break;
  //     case "BUSINESS":
  //       this.seats.push(
  //         {
  //           value: "Y",
  //           viewValue: "Economy",
  //         },
  //         {
  //           value: "M",
  //           viewValue: "Economic Standard",
  //         },
  //         {
  //           value: "W",
  //           viewValue: "Economic Premium",
  //         },
  //         {
  //           value: "C",
  //           viewValue: "Business",
  //         }
  //       );
  //       break;
  //     case "FIRST":
  //       this.seats.push(
  //         {
  //           value: "Y",
  //           viewValue: "Economy",
  //         },
  //         {
  //           value: "W",
  //           viewValue: "Economic Premium",
  //         },
  //         {
  //           value: "M",
  //           viewValue: "Economic Standard",
  //         },
  //         {
  //           value: "C",
  //           viewValue: "Business",
  //         },
  //         {
  //           value: "F",
  //           viewValue: "First",
  //         }
  //       );
  //       break;
  //     default:
  //       this.seats.push(
  //         {
  //           value: "Y",
  //           viewValue: "Economy",
  //         },
  //         {
  //           value: "W",
  //           viewValue: "Economic Premium",
  //         },
  //         {
  //           value: "M",
  //           viewValue: "Economic Standard",
  //         },
  //         {
  //           value: "C",
  //           viewValue: "Business",
  //         },
  //         {
  //           value: "F",
  //           viewValue: "First",
  //         }
  //       );
  //       break;
  //   }
  // }

  private pushAllSeatTypes() {
    this.translate.get("common.all-option").subscribe((allText) => {
      this.seats.push(
        {
          value: "ALL",
          viewValue: allText,
        },
        {
          value: "Y",
          viewValue: "Economy",
        },
        {
          value: "W",
          viewValue: "Economic Premium",
        },
        {
          value: "M",
          viewValue: "Economic Standard",
        },
        {
          value: "C",
          viewValue: "Business",
        },
        {
          value: "F",
          viewValue: "First",
        }
      );
    });
  }

  toggleOneWay() {
    this.oneWay = !this.oneWay;
  }

  getOutMinDate() {
    const minDateWithAdvance = this.getInMinDate();
    return this.utilsService.getOutDateSame(
      minDateWithAdvance,
      this.formSearchFlight.controls["dateIn"].value
    );
  }

  getInMinDate() {
    const daysInAdvance = this.isAdmin ? 0 : (this.userFilters?.flightDaysInAdvance || 0);
    const minDate = moment().add(daysInAdvance, 'days');
    return {
      year: minDate.year(),
      month: minDate.month() + 1,
      day: minDate.date(),
    };
  }

  private applyPolicyDateConstraints(): void {
    if (!this.formSearchFlight) return;

    const dateInCtrl = this.formSearchFlight.get("dateIn");
    const dateOutCtrl = this.formSearchFlight.get("dateOut");

    const dateIn = dateInCtrl?.value;
    const dateOut = dateOutCtrl?.value;

    const minIn = this.getInMinDate();
    const minInMoment = moment({
      year: minIn.year,
      month: minIn.month - 1,
      day: minIn.day,
    });

    if (dateIn) {
      const dateInMoment = moment({
        year: dateIn.year,
        month: dateIn.month - 1,
        day: dateIn.day,
      });

      if (dateInMoment.isBefore(minInMoment, "day")) {
        dateInCtrl?.reset(null);
        dateOutCtrl?.reset(null);

        this.projects = [];
        this.selectedProject = null;
        this.loadingProjects = false;

        return;
      }
    }

    if (this.oneWay) {
      if (dateOut) {
        dateOutCtrl?.reset(null);
      }
      return;
    }

    if (!dateInCtrl?.value && dateOutCtrl?.value) {
      dateOutCtrl?.reset(null);
      return;
    }

    if (dateInCtrl?.value && dateOutCtrl?.value) {
      const outMin = this.getOutMinDate();
      const outMinMoment = moment({
        year: outMin.year,
        month: outMin.month - 1,
        day: outMin.day,
      });

      const dateOutMoment = moment({
        year: dateOut.year,
        month: dateOut.month - 1,
        day: dateOut.day,
      });

      if (dateOutMoment.isBefore(outMinMoment, "day")) {
        dateOutCtrl?.reset(null);

        this.projects = [];
        this.selectedProject = null;
        this.loadingProjects = false;
      }
    }
  }

  getSeatSelected() {
    return this.seats.find(
      (e) => e.value === this.formSearchFlight.controls["type"].value
    )?.viewValue;
  }

  selectSeat(seat: { viewValue: string; value: string }) {
    this.formSearchFlight.controls["type"].setValue(seat.value);
  }

  openTravelersModal() {
    const travelerList = JSON.parse(
      JSON.stringify(
        this.stateService.flightTravelers
      )
    );
    const dialogTravelers = this.dialog.open(DialogTravelersComponent, {
      panelClass: "new-dialog",
      data: {
        travelerList: travelerList,
      },
    });
    dialogTravelers.afterClosed().subscribe((result) => {
      if (result != null) {
        this.stateService.flightTravelers = result;
        this.formSearchFlight.controls["travelers"].setValue(result);
      }
      this.updateTravelers();
    });
  }

  changeTravellers(operation) {
    if (operation === 'add') {
      this.travelers.push('')
      this.stateService.flightTravelers.push('')
      this.formSearchFlight.controls["travelers"].setValue(this.stateService.flightTravelers)
    } else if (operation === 'remove') {
      this.stateService.flightTravelers.pop()
      this.travelers.pop()
      this.formSearchFlight.controls["travelers"].setValue(this.stateService.flightTravelers)
    }
    this.loadPoliciesForCurrentTravelers();
  }

  searchFlights() {
    // this.travelUtilsService.removeTravelLocalStorage();
    // this.openTravelModal();

    this.stateService.flightSearchForm = this.formSearchFlight;
    this.flightAvailRes = null;
    this.outwardList = [];
    this.returnList = [];
    this.searchHasFailed = false;
    this.stateService.flightsGoing = this.outwardList;
    this.stateService.flightsReturn = this.returnList;
    this.stateService.flightSelectedState = null;
    this.stateService.clearAirlines();
    this.stateService.clearAvailableSeats();
    this.loadingFlights = true;
    this.utilsService.loadingFlights = true;
    const journeys: JourneyRequest[] = [];
    const auxAges = this.travelers.map(t =>  moment().diff(t.birthdate, "years"))
    this.stateService.flightTravelers = auxAges;
    const paxes_distribution: PaxesDistribution = {
      passengers_ages: auxAges,
    };
    const formResult = this.formSearchFlight.getRawValue();
    const departDateMonth =
      formResult.dateIn.month < 10
        ? `0${formResult.dateIn.month}`
        : formResult.dateIn.month;
    const departDateDay =
      formResult.dateIn.day < 10
        ? `0${formResult.dateIn.day}`
        : formResult.dateIn.day;
    const departDate = `${formResult.dateIn.year}-${departDateMonth}-${departDateDay}`;
    this.stateService.setFlightSearch(this.formSearchFlight);
    const dateDepartureAux = departDate;
    try {
      const origin = this.originSelected;
      const destination = this.destinationSelected;
      let goSchedule = [];
      if (
        this.stateService.minTimeDeparture !== 0 ||
        this.stateService.maxTimeDeparture !== 24
      ) {
        goSchedule = [
          this.stateService.minTimeDeparture.toString() + ":00",
          this.stateService.maxTimeDeparture.toString() + ":00",
        ];
        if (this.stateService.maxTimeDeparture === 24) {
          goSchedule[1] = "23:59";
        }
      }
      const goFourney: JourneyRequest = {
        max_layover_count: this.formSearchFlight.controls["onlyDirect"].value ? 0 : null,
        date: dateDepartureAux,
        origin: origin,
        destination: destination,
        schedules: goSchedule,
        arrival_same_day:
          this.formSearchFlight.controls["arrivalSameDay"].value,
      };
      if (this.formSearchFlight.value.originNearAirports === true) {
        goFourney.origin_radius = this.originRadius;
      }
      if (this.formSearchFlight.value.destinationNearAirports === true) {
        goFourney.destination_radius = this.destinationRadius;
      }
      journeys.push(goFourney);

      if (
        this.formSearchFlight.controls["roundtrip"].value === true &&
        this.formSearchFlight.controls["dateOut"].value
      ) {
        const returnDateMonth =
          formResult.dateOut.month < 10
            ? `0${formResult.dateOut.month}`
            : formResult.dateOut.month;
        const returnDateDay =
          formResult.dateOut.day < 10
            ? `0${formResult.dateOut.day}`
            : formResult.dateOut.day;
        const returnDate = `${formResult.dateOut.year}-${returnDateMonth}-${returnDateDay}`;
        const dateReturnAux = returnDate;
        let returnSchedule = [];
        if (
          this.stateService.minTimeReturnDeparture !== 0 ||
          this.stateService.maxTimeReturnDeparture !== 24
        ) {
          returnSchedule = [
            this.stateService.minTimeReturnDeparture.toString() + ":00",
            this.stateService.maxTimeReturnDeparture.toString() + ":00",
          ];
          if (this.stateService.maxTimeReturnDeparture === 24) {
            returnSchedule[1] = "23:59";
          }
        }
        const retJourney: JourneyRequest = {
          max_layover_count: this.formSearchFlight.controls["onlyDirect"].value ? 0 : null,
          date: dateReturnAux,
          origin: destination,
          destination: origin,
          schedules: returnSchedule,
          arrival_same_day:
            this.formSearchFlight.controls["arrivalSameDay"].value,
        };
        if (this.formSearchFlight.value.originNearAirports === true) {
          retJourney.origin_radius = this.originRadius;
        }
        if (this.formSearchFlight.value.destinationNearAirports === true) {
          retJourney.destination_radius = this.destinationRadius;
        }
        journeys.push(retJourney);
      }

      const cabinType: CabinType = this.formSearchFlight.controls["type"].value;

      this.transportRequest = {
        //exclude_fares: ["TTOO", "CUPO"],
        include_bus: false,
        include_gds: true,
        include_ndc: true,
        include_train: false,
        journeys: journeys,
        low_cost: true,
        only_flight: true,
        paxes_distribution: paxes_distribution,
        refundable: this.formSearchFlight.controls["allowCancelation"].value,
        baggage: this.formSearchFlight.controls["allowBaggage"].value,
      };

      if (cabinType !== "ALL") {
        this.transportRequest.cabin = cabinType;
      }
      this.stateService.transportRequest = this.transportRequest;

      const rule: Rule = {
        combined: true,
        duplicated: true,
        only_partial: false,
        show_data: true,
        show_partial: false,
      };
      const searchCriteria: SearchCriteria = {
        travel: this.stateService.transportRequest,
        rule: rule,
        // connectors: ["BA"],
      };
      const availabilityPriceRequest: AvailabilityPriceRequest = {
        criterias: [searchCriteria],
      };
      if (this.userUuid) {
        this.flightAvailReq = {
          query: availabilityPriceRequest,
          userUuid: this.userUuid,
        };
      } else {
        this.flightAvailReq = { query: availabilityPriceRequest };
      }
      this.stateService.oneWay = this.oneWay;
      if (this.user.resident && this.user.resident.toString() !== "none") {
        this.flightAvailReq.query.criterias[0].travel["resident"] = this.user.resident;
      }
      this.subcriptions.push(
        this.flightLleegoService.postFlightAvail(this.flightAvailReq).subscribe(
          (res) => {
            this.flightAvailRes = res;
            this.stateService.flightSelectedState = this.flightAvailRes;
            if (
              this.flightAvailRes &&
              this.flightAvailRes.solutions.length > 0 &&
              res !== null
            ) {
              this.stateService.orderByLleego = this.flightAvailRes.solutions;
              this.flightAvailRes.solutions.forEach((solution: Solution) => {
                this.getFlights(solution, 0);
              });
              if (journeys.length === 2) {
                this.flightAvailRes.solutions.forEach((solution: Solution) => {
                  this.getFlights(solution, 1);
                });
              }

              this.loadingFlights = false;
              this.utilsService.loadingFlights = false;

              let selectedUuids = this.travelers.map((u) => u.uuid).slice();
              if (this.userUuid) {
                selectedUuids.unshift(this.userUuid);
              }
              const projectData = {
                selectedProject: this.selectedProject,
                allProjects: this.projects
              };

              this.firstSearch.emit();
              this.emitSelectedTravelers.emit(this.travelers);
              this.emitProject.emit(projectData);
              this.emitCabin.emit(cabinType)
              this.emitSelectedPolicy.emit(this.selectedPolicy);
            } else {
              this.searchHasFailed = true;
              this.subcriptions.push(
                this.translate
                  .get(["flight.form-flight.not-found"])
                  .subscribe((result) => {
                    this.presentToast(
                      "Error",
                      result["flight.form-flight.not-found"]
                    );

                    this.loadingFlights = false;
                    this.utilsService.loadingFlights = false;
                  })
              );
            }
            if (this.modal) {
               this.dialogRef.close({ result: this.flightAvailRes, selectedPolicy: this.selectedPolicy });
            }
          },
          (err) => {
            this.searchHasFailed = true;
            this.loadingFlights = false;
            this.utilsService.loadingFlights = false;
            this.subcriptions.push(
              this.translate
                .get(["flight.form-flight.internal-error"])
                .subscribe((result) => {
                  this.presentToast(
                    "Error",
                    result["flight.form-flight.internal-error"]
                  );
                  this.loadingFlights = false;
                  this.utilsService.loadingFlights = false;
                })
            );
            this.loadingFlights = false;
            this.utilsService.loadingFlights = false;
          }
        )
      );
    } catch (error) {
      this.subcriptions.push(
        this.translate
          .get(["flight.form-flight.search-criteria-error"])
          .subscribe((result) => {
            this.presentToast(
              "Error",
              result["flight.form-flight.search-criteria-error"]
            );
            this.loadingFlights = false;
            this.utilsService.loadingFlights = false;
          })
      );

      if (this.modal) {
        this.dialog.closeAll();
      }
      this.loadingFlights = false;
      this.utilsService.loadingFlights = false;
    }
  }

  getFlights(solution: Solution, index: number) {
    let segmentsRef: string[] = [];
    const solutionId = solution.id;

    solution.data.associations[index]?.journey_references.forEach(
      (journeyId: string) => {
        segmentsRef = this.getSegmentRef(journeyId);
        if (index === 0) {
          this.stateService.flightsGoing.push({
            solution_id: solutionId,
            segments_ref: segmentsRef,
            price: solution.total_price.total,
          });
        } else if (
          index === 1
          // &&
          // this.fS["roundtrip"].value === true
        ) {
          this.stateService.flightsReturn.push({
            solution_id: solution.id,
            segments_ref: segmentsRef,
            price: solution.total_price.total,
          });
        }
        segmentsRef = [];
      }
    );
  }

  getSegmentRef(journeyId: string) {
    const segmentsRef: string[] = [];
    if (journeyId.includes("@")) {
      const segments = journeyId.split("@");
      segments.forEach((segment: string) => {
        segmentsRef.push(segment);
      });
    } else {
      segmentsRef.push(journeyId);
    }
    return segmentsRef;
  }

  goToCreateCustomFlight() {
    this.formSearchFlight.value["oneWay"] = this.oneWay;
    const navigationExtras: NavigationExtras = {
      state: {
        canRequestCustomBooking: this.userFilters.requestCustomBooking,
        canRequestCustomFlight: this.userFilters.requestCustomFlight,
        canRequestCustomTrain: this.userFilters.requestCustomTrain,
        canRequestCustomCar: this.userFilters.requestCar,
        canRequestCustomAirbnb: this.userFilters.requestCustomAirbnb,
        userUuid: this.userToBook ? this.userToBook : this.userUuid,
        companyUuid: this.companyUuid,
        userImageBase64: this.user.image,
        isFromSearchFail: true,
        searchFailData: this.formSearchFlight.value,
      },
    };
    this.router.navigate(["/custom-services/flight"], navigationExtras);
  }

  async presentToast(header: string, msg: string) {
    this.ngxToastrService.typeInfo(header, msg);
  }

  checkIfResident() {
    let text = "";
    if (this.user.resident && this.user.resident.toString() !== "none") {
      if (
        this.munipalitiesList.find((m) => m.municipality === this.user.city && this.user.resident === m.community)
      ) {
        text = "flight.resident-gonna-applied";
      } else {
        text = "flight.resident-city-warning";
      }
    } else {
      text = "flight.resident-warning";
    }
    this.translate.get([text, "common.go-profile"]).subscribe((result) => {
      swal.fire({
        icon: "warning",
        title: "",
        text: result[text],
        showCancelButton: false,
        showConfirmButton: text !== "flight.resident-gonna-applied",
        showCloseButton: true,
        backdrop: true,
        confirmButtonText: result["common.go-profile"]
      }).then((action) => {
        if (action.value) {
          this.router.navigate([this.isAdmin ? "/user/edit-user/" + this.user.uuid : "/user/user-profile"]);
        }
      });
    });
  }

  getCompanyUsers() {
    if (!this.companyUuid) {
      this.userService.getUser(this.userUuid).subscribe(
        (res) => {
          this.companyUuid = res.companyUuid;
          this.fetchCompanyUsers();
        },
        (err) => {}
      );
    } else {
      this.fetchCompanyUsers();
    }
  }

  fetchCompanyUsers() {
    if (this.companyUuid) {
      this.companyService.getCompanyUsers(this.companyUuid).subscribe(
        (res) => {
          this.companyUsers = res;
          
          this.filteredUsers = this.companyUsers;
          this.setInitialTraveler();
        },
        (err) => {}
      );
    }
  }

  setInitialTraveler() {
    const user = this.companyUsers.find((user) => user.uuid === this.userUuid);
    if (user) {
      this.defaultUser = user;
      if (!this.travelers.find((t) => t.uuid === this.userUuid)) {
        this.travelers.push(this.defaultUser)
        this.formSearchFlight.controls["travelers"].setValue(this.travelers)

      }
    }
    this.loadPoliciesForCurrentTravelers();
    /* if (!this.travelersSelected) {
      this.updateTravelers();
    } */
  }


  updateTravelers() {
    const user = this.companyUsers.find((user) => user.uuid === this.userUuid);
    if (user) {
      this.defaultUser = user;
    }
    for (let i = this.travelers.length; i < this.stateService.flightTravelers.length - 1; i++) {
      if (!this.travelers[i]) {
        this.travelers[i] = "";
      }
    }
    if (this.travelers.length > this.stateService.flightTravelers.length - 1) {
      this.travelers = this.travelers.slice(0, this.stateService.flightTravelers.length - 1);
    }
    setTimeout(() => {
      this.travelers = [...this.travelers];
    });
  }
  
  

  applyFilter(filterValue: string) {
    this.filteredUsers = this.companyUsers.filter(user =>
      `${user.name} ${user.lastname}`.toLowerCase().includes(filterValue.toLowerCase())
    );
  }
  
  onPanelClose() {
    this.filterControl.setValue('');
    this.filteredUsers = this.companyUsers;
  }
  
  onOpenedChange(event: boolean, input: HTMLInputElement) {
    if (event) {
      input.focus();
    }
  }

  compareUsers(user1: any, user2: any): boolean {
    return user1?.uuid === user2?.uuid;
  }

  allTravelersSelected(): boolean {
    return this.travelers.every(t => t && t.uuid);
  }
  
  trackByIndex(index: number) {
    return index;
  }

  onDateChange() {
    if(!this.oneWay){
      if (this.formSearchFlight.controls['dateIn'].value && this.formSearchFlight.controls['dateOut'].value) {
        const checkInParam = this.transformDateToISO(this.formSearchFlight.controls['dateIn'].value);
        const checkOutParam = this.transformDateToISO(this.formSearchFlight.controls['dateOut'].value);
        this.loadProjects(checkInParam, checkOutParam);
      }
    }else{
      if (this.formSearchFlight.controls['dateIn'].value){
        const checkInParam = this.transformDateToISO(this.formSearchFlight.controls['dateIn'].value);
        this.loadProjects(checkInParam);
      }
    }
  }

  transformDateToISO(date: { year: number, month: number, day: number }): string {
    const { year, month, day } = date;
    const jsDate = new Date(Date.UTC(year, month - 1, day));
    const datePart = jsDate.toISOString().split('T')[0];
    return `${datePart}T00:00:00.000+00:00`;
  }


  loadProjects(checkIn: any, checkOut?: any){
    this.loadingProjects = true;
  
    this.travelService.getTravelsWithParams({ companyUuid: this.companyUuid })
      .subscribe(resp => {
        this.projects = [];
        const defaultProject = {
          title: "--------No-------- ",
          uuid: "none",
        };
  
        this.projects.push(defaultProject);
        this.projects = this.projects.concat(resp.docs);
        
        this.projects = this.projects.filter((project) => {
          if (project.initDate && project.endDate) {
            const projectDatesAreCorrect = this.checkDatesAreCorrect(
              checkIn,
              checkOut,
              moment(project.initDate),
              moment(project.endDate)
            );
            return projectDatesAreCorrect;
          } else {
            return true;
          }
        });
        
        this.selectedProject = this.projects.find(project => project.uuid === 'none');
        this.loadingProjects = false;
      }, error => {
        this.loadingProjects = false;
      });
  }

  checkDatesAreCorrect(
    bookingInitDate,
    bookingEndDate,
    projectInitDate,
    projectEndDate
  ) {
    let projectDatesAreCorrect = true;
    if (bookingInitDate != null) {
      const momentInitDate = moment(bookingInitDate);
      projectDatesAreCorrect = moment(projectInitDate).isSameOrBefore(
        momentInitDate,
        "day"
      );
      if (bookingEndDate != null && projectDatesAreCorrect) {
        const momentEndDate = moment(bookingEndDate);
        projectDatesAreCorrect = moment(projectEndDate).isSameOrAfter(
          momentEndDate,
          "day"
        );
      } else {
        if (bookingEndDate == null && projectDatesAreCorrect) {
          projectDatesAreCorrect = moment(projectEndDate).isSameOrAfter(
            momentInitDate,
            "day"
          );
        }
      }
    }
    return projectDatesAreCorrect;
  }

  openTravelDialog(){
    const modalRef = this.dialog.open(DialogAssignProjectComponent, {
      data: {
        create: true,
        isOnlyCreate: true,
        userUuid: this.userUuid,
        companyUuid: this.companyUuid,
      },
      panelClass: "new-dialog",
    });

    modalRef.afterClosed().subscribe((result) => {
      if (result != null) {
        if (this.userUuid !== null) {
          result.travelData["userUuid"] = this.userUuid;
        }

        if (this.companyUuid !== null) {
          result.travelData["companyUuid"] = this.companyUuid;
        }
        if (
          result.travelData["endDate"] === "" &&
          result.travelData["initDate"] === ""
        ) {
          delete result.travelData["endDate"];
          delete result.travelData["initDate"];
        }
        this.subcriptions.push(
          this.travelService.postTravel(result.travelData).subscribe(
            (res) => {

              let dateIn = this.formSearchFlight.controls['dateIn'].value;
              let dateOut = this.formSearchFlight.controls['dateOut'].value || null;

              const checkInFormat = moment({
                year: dateIn.year,
                month: dateIn.month - 1,
                day: dateIn.day
              });

              let checkOutFormat = null;
              if (dateOut) {
                checkOutFormat = moment({
                  year: dateOut.year,
                  month: dateOut.month - 1,
                  day: dateOut.day
                });
              }
              
              const projectInitDate = moment(res.initDate);
              const projectEndDate = moment(res.endDate);

              if (!checkOutFormat) {
                const isWithinRange = checkInFormat.isBetween(projectInitDate, projectEndDate, null, '[]');
                if (isWithinRange || (!res.initDate && !res.endDate)) {
                  this.projects.push(res);
                  this.selectedProject = res;
                }
              } else {
                const isWithinRange = checkInFormat.isBetween(projectInitDate, projectEndDate, null, '[]') &&
                                      checkOutFormat.isBetween(projectInitDate, projectEndDate, null, '[]');
                if (isWithinRange || (!res.initDate && !res.endDate)) {
                  this.projects.push(res);
                  this.selectedProject = res;
                }
              }

              this.subcriptions.push(
                this.translate
                  .get(`project.my-projects.created`)
                  .subscribe((resp) => {
                    this.ngxToastrService.typeSuccess(null, resp);
                    setTimeout(() => {
                    }, 3000);
                  })
              );
            },
            (err) => {
              this.subcriptions.push(
                this.translate.get("common.error").subscribe((resp) => {
                  this.ngxToastrService.typeInfo(resp, err.error.message);
                })
              );
            }
          )
        );
      }
    });
  }

  togglePassengersModal() {
    this.passengersModalOpen = !this.passengersModalOpen;
  }

  closePassengersModal() {
    this.passengersModalOpen = false;
    console.log(this.passengersModalOpen)
  }

  private getAllTravelerUuids(): string[] {
    const set = new Set<string>();

    (this.travelers || []).forEach((t: any) => {
      const uuid = t?.uuid;
      if (uuid) set.add(uuid);
    });

    if (this.userUuid && !set.has(this.userUuid)) {
      set.add(this.userUuid);
    }

    return Array.from(set);
  }

  private loadPoliciesForCurrentTravelers(): void {
    const travelerUuids = this.getAllTravelerUuids();
    const requestKey = travelerUuids.slice().sort().join("|");
    this.lastPoliciesRequestKey = requestKey;

    if (!travelerUuids.length) {
      this.policies = [];
      this.selectedPolicy = null;
      this.loadingPolicies = false;
      return;
    }

    if (this.policiesSub) {
      this.policiesSub.unsubscribe();
      this.policiesSub = undefined;
    }

    this.loadingPolicies = true;

    const requests = travelerUuids.map((userUuid) => {
      if (this.userPoliciesCache[userUuid]) {
        return of(this.userPoliciesCache[userUuid]);
      }

      return this.userService.getPoliciesUser(userUuid).pipe(
        tap((policies: any) => {
          const normalized = Array.isArray(policies)
            ? policies
            : (policies ? [policies] : []);
          this.userPoliciesCache[userUuid] = normalized;
        }),
        catchError((_err) => {
          this.userPoliciesCache[userUuid] = [];
          return of([]);
        })
      );
    });

    this.policiesSub = forkJoin(requests).subscribe({
      next: (results: any[][]) => {
        if (this.lastPoliciesRequestKey !== requestKey) return;

        const allPolicies = results.reduce(
          (acc: any[], arr: any[]) => acc.concat(arr || []),
          []
        );

        const unique: any[] = [];
        const seen = new Set<string>();
        for (const p of allPolicies) {
          const id = p?.uuid || p?._id || p?.name;
          if (!id) continue;
          if (!seen.has(id)) {
            seen.add(id);
            unique.push(p);
          }
        }

        const canUseFlightPolicy = (p: any) => {
          if (this.isAdmin) return true;

          return p?.filters?.requestFlight !== false;
        };

        this.policies = unique.filter(canUseFlightPolicy);

        const getId = (p: any) => p && (p.uuid || p._id || p.name);
        const currentSelectedId = getId(this.selectedPolicy);

        if (currentSelectedId) {
          const matched = this.policies.find(p => getId(p) === currentSelectedId);
          this.selectedPolicy = matched ?? null;
        }

        if (!this.selectedPolicy) {
          const cachedForDefault = this.userPoliciesCache[this.defaultUser?.uuid];
          const defaultCandidate = Array.isArray(cachedForDefault) ? cachedForDefault[0] : null;

          const defaultValid =
            (defaultCandidate && this.policies.find(p => getId(p) === getId(defaultCandidate))) ||
            this.policies[0] ||
            null;

          this.selectedPolicy = defaultValid;
        }

        this.userFilters = this.selectedPolicy?.filters || this.userFilters;
        this.applyPolicyDateConstraints();
        this.onDateChange();
        this.loadingPolicies = false;
      },
      error: (_e) => {
        if (this.lastPoliciesRequestKey !== requestKey) return;
        this.loadingPolicies = false;
        this.policies = [];
        this.selectedPolicy = null;
      },
    });

    this.subcriptions.push(this.policiesSub);
  }

  onPolicyChange(policy: any) {
    this.selectedPolicy = policy;
    this.userFilters = policy?.filters || this.userFilters;
    this.applyPolicyDateConstraints();
    this.onDateChange();
  }

  onTravelersChanged() {
    this.loadPoliciesForCurrentTravelers();
  }

  getTotalPriceAccom() {
    let totalPrice = 0;
    this.accomInfo.selectedRooms.forEach((room) => {
      room.rates.forEach((rate) => {
        totalPrice += rate.price && rate.price.totalPrice ? Number(rate.price.totalPrice.total) : Number(rate.totalWithPercentage);
      })
    })
    return totalPrice;
  }

  getTotalPackage() {
    return this.getTotalPriceAccom()
  }

  changePackageRate() {
    this.isPackageRate = this.isPackageRate === 'flight' ? null : this.isPackageRate = 'flight'
    localStorage.setItem('isPackageRate', this.isPackageRate);
  }
}
